// ============================================
// Demo Mock Data - 실제 API 응답 형식에 맞춤
// ============================================

// 공장 목록 (Home.jsx, Factory.jsx용)
export const mockFactories = [
  { id: 1, factoryName: '본사 공장', address: '경기도 화성시 동탄대로 123', lineCount: 3, totalEquipment: 8, runningEquipment: 6, idleEquipment: 1, stoppedEquipment: 1 },
  { id: 2, factoryName: '제2공장', address: '충청남도 천안시 서북구 456', lineCount: 2, totalEquipment: 4, runningEquipment: 3, idleEquipment: 1, stoppedEquipment: 0 },
  { id: 3, factoryName: '제3공장', address: '경상북도 구미시 산동면 789', lineCount: 2, totalEquipment: 6, runningEquipment: 5, idleEquipment: 1, stoppedEquipment: 0 }
];

// 설비 목록 (Machine.jsx, EquipmentListPage.jsx용)
export const mockEquipments = [
  { id: 1, equipmentId: 1, equipmentName: 'INJ-001', equipmentCode: 'EQ-001', factoryId: 1, factoryName: '본사 공장', lineId: 1, lineName: 'A라인', status: 'RUNNING', model: 'SE180EV', manufacturer: '스미토모', tonnage: 180, serialNumber: 'SN-2024-0001', maxTemperature: 300, maxPressure: 200, targetCycleTime: 28, cavityCount: 4, lastInspectionDate: '2025-12-10' },
  { id: 2, equipmentId: 2, equipmentName: 'INJ-002', equipmentCode: 'EQ-002', factoryId: 1, factoryName: '본사 공장', lineId: 1, lineName: 'A라인', status: 'RUNNING', model: 'SE220EV', manufacturer: '스미토모', tonnage: 220, serialNumber: 'SN-2024-0002', maxTemperature: 320, maxPressure: 220, targetCycleTime: 30, cavityCount: 4, lastInspectionDate: '2025-12-10' },
  { id: 3, equipmentId: 3, equipmentName: 'INJ-003', equipmentCode: 'EQ-003', factoryId: 1, factoryName: '본사 공장', lineId: 1, lineName: 'A라인', status: 'IDLE', model: 'SE280EV', manufacturer: '스미토모', tonnage: 280, serialNumber: 'SN-2024-0003', maxTemperature: 350, maxPressure: 250, targetCycleTime: 32, cavityCount: 6, lastInspectionDate: '2025-12-08' },
  { id: 4, equipmentId: 4, equipmentName: 'INJ-004', equipmentCode: 'EQ-004', factoryId: 1, factoryName: '본사 공장', lineId: 2, lineName: 'B라인', status: 'RUNNING', model: 'CLF-350', manufacturer: 'LS엠트론', tonnage: 350, serialNumber: 'SN-2024-0004', maxTemperature: 380, maxPressure: 280, targetCycleTime: 35, cavityCount: 8, lastInspectionDate: '2025-12-05' },
  { id: 5, equipmentId: 5, equipmentName: 'INJ-005', equipmentCode: 'EQ-005', factoryId: 1, factoryName: '본사 공장', lineId: 2, lineName: 'B라인', status: 'STOPPED', model: 'CLF-450', manufacturer: 'LS엠트론', tonnage: 450, serialNumber: 'SN-2024-0005', maxTemperature: 400, maxPressure: 300, targetCycleTime: 38, cavityCount: 8, lastInspectionDate: '2025-12-03' },
  { id: 6, equipmentId: 6, equipmentName: 'INJ-006', equipmentCode: 'EQ-006', factoryId: 1, factoryName: '본사 공장', lineId: 2, lineName: 'B라인', status: 'RUNNING', model: 'CLF-550', manufacturer: 'LS엠트론', tonnage: 550, serialNumber: 'SN-2024-0006', maxTemperature: 420, maxPressure: 320, targetCycleTime: 40, cavityCount: 12, lastInspectionDate: '2025-12-02' },
  { id: 7, equipmentId: 7, equipmentName: 'INJ-007', equipmentCode: 'EQ-007', factoryId: 1, factoryName: '본사 공장', lineId: 3, lineName: 'C라인', status: 'RUNNING', model: 'J350AD', manufacturer: 'JSW', tonnage: 350, serialNumber: 'SN-2024-0007', maxTemperature: 380, maxPressure: 280, targetCycleTime: 35, cavityCount: 8, lastInspectionDate: '2025-12-01' },
  { id: 8, equipmentId: 8, equipmentName: 'INJ-008', equipmentCode: 'EQ-008', factoryId: 1, factoryName: '본사 공장', lineId: 3, lineName: 'C라인', status: 'RUNNING', model: 'J450AD', manufacturer: 'JSW', tonnage: 450, serialNumber: 'SN-2024-0008', maxTemperature: 400, maxPressure: 300, targetCycleTime: 38, cavityCount: 8, lastInspectionDate: '2025-12-15' },
  { id: 9, equipmentId: 9, equipmentName: 'INJ-009', equipmentCode: 'EQ-009', factoryId: 2, factoryName: '제2공장', lineId: 4, lineName: 'D라인', status: 'RUNNING', model: 'SE180EV', manufacturer: '스미토모', tonnage: 180, serialNumber: 'SN-2024-0009', maxTemperature: 300, maxPressure: 200, targetCycleTime: 28, cavityCount: 4, lastInspectionDate: '2025-12-18' },
  { id: 10, equipmentId: 10, equipmentName: 'INJ-010', equipmentCode: 'EQ-010', factoryId: 2, factoryName: '제2공장', lineId: 4, lineName: 'D라인', status: 'IDLE', model: 'SE220EV', manufacturer: '스미토모', tonnage: 220, serialNumber: 'SN-2024-0010', maxTemperature: 320, maxPressure: 220, targetCycleTime: 30, cavityCount: 4, lastInspectionDate: '2025-12-20' },
  { id: 11, equipmentId: 11, equipmentName: 'INJ-011', equipmentCode: 'EQ-011', factoryId: 2, factoryName: '제2공장', lineId: 5, lineName: 'E라인', status: 'RUNNING', model: 'CLF-350', manufacturer: 'LS엠트론', tonnage: 350, serialNumber: 'SN-2024-0011', maxTemperature: 380, maxPressure: 280, targetCycleTime: 35, cavityCount: 8, lastInspectionDate: '2025-12-12' },
  { id: 12, equipmentId: 12, equipmentName: 'INJ-012', equipmentCode: 'EQ-012', factoryId: 2, factoryName: '제2공장', lineId: 5, lineName: 'E라인', status: 'RUNNING', model: 'CLF-450', manufacturer: 'LS엠트론', tonnage: 450, serialNumber: 'SN-2024-0012', maxTemperature: 400, maxPressure: 300, targetCycleTime: 38, cavityCount: 8, lastInspectionDate: '2025-12-22' }
];

// 공장 라인 목록
export const mockFactoryLines = {
  1: [
    { id: 1, lineName: 'A라인', equipmentCount: 3 },
    { id: 2, lineName: 'B라인', equipmentCount: 3 },
    { id: 3, lineName: 'C라인', equipmentCount: 2 }
  ],
  2: [
    { id: 4, lineName: 'D라인', equipmentCount: 2 },
    { id: 5, lineName: 'E라인', equipmentCount: 2 }
  ],
  3: [
    { id: 6, lineName: 'F라인', equipmentCount: 3 },
    { id: 7, lineName: 'G라인', equipmentCount: 3 }
  ]
};

// 전사 대시보드 (Enterprise.jsx용)
export const mockCompanyDashboard = {
  kpiCards: {
    totalFactories: 3,
    totalEquipment: 18,
    runningEquipment: 14,
    idleEquipment: 3,
    stoppedEquipment: 1,
    operatingRate: 77.8,
    dailyProduction: 15420,
    energyConsumption: 2450.5
  },
  oeeMetrics: {
    oee: 82.5,
    availability: 92.3,
    performance: 95.1,
    quality: 94.0
  },
  factoryStatuses: mockFactories.map((f, idx) => ({
    factoryId: f.id,
    factoryName: f.factoryName,
    factoryCode: `FAC-00${f.id}`,
    totalEquipment: f.totalEquipment,
    runningEquipment: f.runningEquipment,
    idleEquipment: f.idleEquipment,
    stoppedEquipment: f.stoppedEquipment,
    operatingRate: Math.round((f.runningEquipment / f.totalEquipment) * 100),
    production: [8500, 4200, 2720][idx] || 0,
    alarmCount: [2, 0, 0][idx] || 0
  })),
  productionTrend: {
    // 90일 데이터 생성
    dates: Array.from({ length: 90 }, (_, i) => {
      const d = new Date();
      d.setDate(d.getDate() - (89 - i));
      return d.toISOString().split('T')[0];
    }),
    // 90일간 생산량 데이터 (12000~16000 사이로 자연스러운 변동)
    productionCounts: Array.from({ length: 90 }, (_, i) => {
      const base = 14000 + Math.sin(i * 0.08) * 1500;
      const noise = (Math.random() - 0.5) * 2000;
      // 주말(토,일)은 생산량 감소
      const dayOfWeek = new Date(Date.now() - (89 - i) * 24 * 60 * 60 * 1000).getDay();
      const weekendFactor = (dayOfWeek === 0 || dayOfWeek === 6) ? 0.6 : 1;
      return Math.round((base + noise) * weekendFactor);
    }),
    // 90일간 가동률 데이터 (70~85% 사이로 변동)
    operatingRates: Array.from({ length: 90 }, (_, i) => {
      const base = 77 + Math.sin(i * 0.1) * 4;
      const noise = (Math.random() - 0.5) * 6;
      // 주말은 가동률 감소
      const dayOfWeek = new Date(Date.now() - (89 - i) * 24 * 60 * 60 * 1000).getDay();
      const weekendFactor = (dayOfWeek === 0 || dayOfWeek === 6) ? 0.85 : 1;
      return Math.round((base + noise) * weekendFactor);
    })
  },
  oeeTrend: {
    // 90일 데이터 생성
    dates: Array.from({ length: 90 }, (_, i) => {
      const d = new Date();
      d.setDate(d.getDate() - (89 - i));
      return d.toISOString().split('T')[0];
    }),
    // 90일간 OEE 데이터 (75~88 사이로 자연스러운 변동)
    oee: Array.from({ length: 90 }, (_, i) => {
      const base = 80 + Math.sin(i * 0.1) * 3;
      const noise = (Math.random() - 0.5) * 4;
      return Math.round((base + noise) * 10) / 10;
    }),
    availability: Array.from({ length: 90 }, (_, i) => {
      const base = 90 + Math.sin(i * 0.08) * 2;
      const noise = (Math.random() - 0.5) * 3;
      return Math.round((base + noise) * 10) / 10;
    }),
    performance: Array.from({ length: 90 }, (_, i) => {
      const base = 93 + Math.sin(i * 0.12) * 2;
      const noise = (Math.random() - 0.5) * 3;
      return Math.round((base + noise) * 10) / 10;
    }),
    quality: Array.from({ length: 90 }, (_, i) => {
      const base = 93 + Math.sin(i * 0.09) * 1.5;
      const noise = (Math.random() - 0.5) * 2;
      return Math.round((base + noise) * 10) / 10;
    })
  },
  lastSyncTime: new Date().toISOString()
};

// 전사 공장 현황 (EnterpriseFactoryOverview.jsx용)
export const mockCompanyFactoryOverview = {
  factories: mockFactories.map((f, fIdx) => ({
    factoryId: f.id,
    factoryName: f.factoryName,
    address: f.address,
    equipment: {
      running: f.runningEquipment,
      idle: f.idleEquipment,
      stopped: f.stoppedEquipment,
      total: f.totalEquipment
    },
    operationRate: Math.round((f.runningEquipment / f.totalEquipment) * 100),
    machines: mockEquipments.filter(e => e.factoryId === f.id).map((e, idx) => ({
      equipmentId: e.id,
      equipmentName: e.equipmentName,
      status: e.status === 'RUNNING' ? 'OPERATING' : e.status === 'IDLE' ? 'STANDBY' : 'STOPPED',
      utilization: e.status === 'RUNNING' ? 75 + Math.random() * 20 : 0,
      shotCount: 1500 + Math.floor(Math.random() * 5000),
      productName: ['기어 하우징', '커넥터 케이스', '버튼 캡', '센서 커버'][idx % 4],
      cavityCount: e.cavityCount,
      cycleTime: e.targetCycleTime,
      alarms: e.status === 'STOPPED' ? 1 : 0
    })),
    recentAlarms: fIdx === 0 ? [
      { alarmId: 1, code: 'A001', message: '유압유 온도 경고', severity: 'WARNING', equipmentId: 1, equipmentName: 'INJ-001', occurredAt: new Date(Date.now() - 3600000).toISOString() },
      { alarmId: 2, code: 'E001', message: '설비 정지', severity: 'ERROR', equipmentId: 5, equipmentName: 'INJ-005', occurredAt: new Date(Date.now() - 7200000).toISOString() }
    ] : [],
    alarms: { total: fIdx === 0 ? 2 : 0 }
  })),
  lastSyncTime: new Date().toISOString()
};

// 공장 대시보드 (Factory.jsx용)
export const mockFactoryDashboard = {
  1: {
    factoryInfo: { factoryName: '본사 공장', address: '경기도 화성시 동탄대로 123' },
    kpiCards: {
      totalMachines: 8,
      runningMachines: 6,
      idleMachines: 1,
      stoppedMachines: 1,
      overallUtilization: 75.0,
      dailyProduction: 8500,
      energyUsage: 1250.5
    },
    lineStatuses: [
      { lineId: 1, lineName: 'A라인', machines: 3, running: 2, idle: 1, stopped: 0, utilization: 78.5, production: 3200, alarmTimes: [8, 14] },
      { lineId: 2, lineName: 'B라인', machines: 3, running: 2, idle: 0, stopped: 1, utilization: 65.2, production: 2800, alarmTimes: [10] },
      { lineId: 3, lineName: 'C라인', machines: 2, running: 2, idle: 0, stopped: 0, utilization: 82.1, production: 2500, alarmTimes: [] }
    ],
    alarmStatus: {
      activeCount: 2,
      alarmList: [
        { alarmId: 1, code: 'A001', message: '유압유 온도 경고', severity: 'WARNING', equipmentId: 1, machine: 'INJ-001', occurredAt: new Date(Date.now() - 3600000).toISOString() },
        { alarmId: 2, code: 'E001', message: '설비 정지', severity: 'ERROR', equipmentId: 5, machine: 'INJ-005', occurredAt: new Date(Date.now() - 7200000).toISOString() }
      ],
      summary: { criticalCount: 0, warningCount: 1, infoCount: 0 }
    },
    lastSyncTime: new Date().toISOString()
  },
  2: {
    factoryInfo: { factoryName: '제2공장', address: '충청남도 천안시 서북구 456' },
    kpiCards: {
      totalMachines: 4,
      runningMachines: 3,
      idleMachines: 1,
      stoppedMachines: 0,
      overallUtilization: 75.0,
      dailyProduction: 4200,
      energyUsage: 680.3
    },
    lineStatuses: [
      { lineId: 4, lineName: 'D라인', machines: 2, running: 1, idle: 1, stopped: 0, utilization: 72.3, production: 1800, alarmTimes: [] },
      { lineId: 5, lineName: 'E라인', machines: 2, running: 2, idle: 0, stopped: 0, utilization: 85.7, production: 2400, alarmTimes: [] }
    ],
    alarmStatus: {
      activeCount: 0,
      alarmList: [],
      summary: { criticalCount: 0, warningCount: 0, infoCount: 0 }
    },
    lastSyncTime: new Date().toISOString()
  },
  3: {
    factoryInfo: { factoryName: '제3공장', address: '경상북도 구미시 산동면 789' },
    kpiCards: {
      totalMachines: 6,
      runningMachines: 5,
      idleMachines: 1,
      stoppedMachines: 0,
      overallUtilization: 83.3,
      dailyProduction: 2720,
      energyUsage: 520.2
    },
    lineStatuses: [
      { lineId: 6, lineName: 'F라인', machines: 3, running: 3, idle: 0, stopped: 0, utilization: 88.2, production: 1500, alarmTimes: [] },
      { lineId: 7, lineName: 'G라인', machines: 3, running: 2, idle: 1, stopped: 0, utilization: 78.4, production: 1220, alarmTimes: [16] }
    ],
    alarmStatus: {
      activeCount: 0,
      alarmList: [],
      summary: { criticalCount: 0, warningCount: 0, infoCount: 0 }
    },
    lastSyncTime: new Date().toISOString()
  }
};

// 사출기 대시보드 (FactoryMachineOverview.jsx용)
// status: 소문자 (running, idle, stopped)
// timeline: 24개의 상태 배열 (running/idle/stopped)
export const mockMachineDashboard = {
  1: {
    machines: mockEquipments.filter(e => e.factoryId === 1).map((e, idx) => ({
      id: e.id,
      name: e.equipmentName,
      lineId: e.lineId,
      status: e.status === 'RUNNING' ? 'running' : e.status === 'IDLE' ? 'idle' : 'stopped',
      utilization: e.status === 'RUNNING' ? 70 + Math.random() * 25 : 0,
      alarms: e.status === 'STOPPED' ? 1 : 0,
      shotNo: Math.floor(1000 + Math.random() * 5000),
      productName: ['기어 하우징', '커넥터 케이스', '버튼 캡', '센서 커버'][idx % 4],
      cavityCount: e.cavityCount,
      cycleTime: Math.round((e.targetCycleTime + (Math.random() - 0.5) * 4) * 10) / 10,
      timeline: Array.from({ length: 24 }, (_, i) => {
        const baseStatus = e.status === 'RUNNING' ? 'running' : e.status === 'IDLE' ? 'idle' : 'stopped';
        return i < 6 ? 'idle' : i > 22 ? 'idle' : baseStatus;
      })
    })),
    lastSyncTime: new Date().toISOString()
  },
  2: {
    machines: mockEquipments.filter(e => e.factoryId === 2).map((e, idx) => ({
      id: e.id,
      name: e.equipmentName,
      lineId: e.lineId,
      status: e.status === 'RUNNING' ? 'running' : e.status === 'IDLE' ? 'idle' : 'stopped',
      utilization: e.status === 'RUNNING' ? 70 + Math.random() * 25 : 0,
      alarms: 0,
      shotNo: Math.floor(1000 + Math.random() * 5000),
      productName: ['커넥터 케이스', '버튼 캡', '센서 커버', '기어 하우징'][idx % 4],
      cavityCount: e.cavityCount,
      cycleTime: Math.round((e.targetCycleTime + (Math.random() - 0.5) * 4) * 10) / 10,
      timeline: Array.from({ length: 24 }, (_, i) => {
        const baseStatus = e.status === 'RUNNING' ? 'running' : e.status === 'IDLE' ? 'idle' : 'stopped';
        return i < 6 ? 'idle' : i > 22 ? 'idle' : baseStatus;
      })
    })),
    lastSyncTime: new Date().toISOString()
  },
  3: {
    machines: mockEquipments.filter(e => e.factoryId === 3).map((e, idx) => ({
      id: e.id,
      name: e.equipmentName,
      lineId: e.lineId,
      status: e.status === 'RUNNING' ? 'running' : e.status === 'IDLE' ? 'idle' : 'stopped',
      utilization: e.status === 'RUNNING' ? 70 + Math.random() * 25 : 0,
      alarms: 0,
      shotNo: Math.floor(1000 + Math.random() * 5000),
      productName: ['버튼 캡', '센서 커버', '기어 하우징', '커넥터 케이스'][idx % 4],
      cavityCount: e.cavityCount,
      cycleTime: Math.round((e.targetCycleTime + (Math.random() - 0.5) * 4) * 10) / 10,
      timeline: Array.from({ length: 24 }, (_, i) => {
        const baseStatus = e.status === 'RUNNING' ? 'running' : e.status === 'IDLE' ? 'idle' : 'stopped';
        return i < 6 ? 'idle' : i > 22 ? 'idle' : baseStatus;
      })
    })),
    lastSyncTime: new Date().toISOString()
  }
};

// 사출기 개요 (Machine.jsx Overview용)
export const mockMachineOverview = {
  factoryInfo: { factoryName: '본사 공장', lineName: 'A라인' },
  // 기본정보 - 객체 형태
  basicInfo: {
    productName: '62-1',
    shotCount: 577,
    cycleTime: 29.8,
    cavityCount: 4
  },
  // 사출 정보
  injection: {
    maxPressure: 76.0,
    startPosition: 34.1,
    switchPosition: 7.7,
    time: 5.3,
    speed: 30.0,
    suckbackTime: 0.57,
    suckbackSpeed: 50.0
  },
  // 보압 정보
  holding: {
    switchMode: '위치',
    switchInput: 8.4,
    pressure1: 45.0,
    pressure2: 42.0,
    time1: 2.0,
    time2: 1.5
  },
  // 계량 정보
  metering: {
    position: 34.1,
    speed: 80,
    pressure: 5.0,
    time: 3.1
  },
  // 금형 정보
  mold: {
    thickness: 350,
    openPosition: 261.6,
    closePosition: 0,
    openTime: 2.86,
    closeTime: 2.68,
    temp1: 45,
    temp2: 42
  },
  // 이젝터 정보
  ejector: {
    forwardPosition: 25.0,
    backwardPosition: 0,
    forwardSpeed: 80,
    backwardSpeed: 60
  },
  // 히터 온도 정보 - zones 배열 형태
  heater: {
    zones: [
      { zoneName: '노즐온도', currentTemp: 215, tempTrend: Array.from({ length: 20 }, () => 215 + (Math.random() - 0.5) * 3) },
      { zoneName: '바렐1', currentTemp: 218.5, tempTrend: Array.from({ length: 20 }, () => 218.5 + (Math.random() - 0.5) * 2) },
      { zoneName: '바렐2', currentTemp: 204.3, tempTrend: Array.from({ length: 20 }, () => 204.3 + (Math.random() - 0.5) * 2) },
      { zoneName: '바렐3', currentTemp: 211.2, tempTrend: Array.from({ length: 20 }, () => 211.2 + (Math.random() - 0.5) * 2) },
      { zoneName: '바렐4', currentTemp: 219.8, tempTrend: Array.from({ length: 20 }, () => 219.8 + (Math.random() - 0.5) * 2) },
      { zoneName: '바렐5', currentTemp: 220.1, tempTrend: Array.from({ length: 20 }, () => 220.1 + (Math.random() - 0.5) * 2) }
    ]
  },
  lastSyncTime: new Date().toISOString()
};

// 사출기 사이클 데이터 (Machine.jsx Cycle용)
export const mockMachineCycle = {
  // 사출 프로파일 - injectionProfile.data[].profile[] (step, pressure, speed)
  injectionProfile: {
    data: [
      {
        shotNumber: 577,
        profile: Array.from({ length: 21 }, (_, i) => {
          const step = i * 0.05;
          // 사출 압력: 0에서 시작해서 빠르게 상승 후 감소
          const pressure = step < 0.3 ? step * 250 : step < 0.6 ? 75 - (step - 0.3) * 100 : 45 - (step - 0.6) * 50;
          // 사출 속도: 초반에 높고 점점 감소
          const speed = step < 0.2 ? 30 + step * 200 : step < 0.5 ? 70 - (step - 0.2) * 100 : 40 - (step - 0.5) * 40;
          return { step, pressure: Math.max(0, pressure), speed: Math.max(0, speed) };
        })
      },
      {
        shotNumber: 576,
        profile: Array.from({ length: 21 }, (_, i) => {
          const step = i * 0.05;
          const pressure = step < 0.3 ? step * 245 : step < 0.6 ? 73.5 - (step - 0.3) * 98 : 44 - (step - 0.6) * 48;
          const speed = step < 0.2 ? 29 + step * 195 : step < 0.5 ? 68 - (step - 0.2) * 97 : 39 - (step - 0.5) * 38;
          return { step, pressure: Math.max(0, pressure), speed: Math.max(0, speed) };
        })
      }
    ]
  },
  // 보압 프로파일 - holdingProfile.data[].profile[] (step, holding, time)
  holdingProfile: {
    data: [
      {
        shotNumber: 577,
        profile: Array.from({ length: 21 }, (_, i) => {
          const step = i * 0.05;
          // 보압: 초기에 높고 단계적으로 감소
          const holding = step < 0.3 ? 45 : step < 0.6 ? 42 : step < 0.8 ? 38 : 35;
          // 시간: 선형 증가
          const time = step * 5.3;
          return { step, holding, time };
        })
      },
      {
        shotNumber: 576,
        profile: Array.from({ length: 21 }, (_, i) => {
          const step = i * 0.05;
          const holding = step < 0.3 ? 44 : step < 0.6 ? 41 : step < 0.8 ? 37 : 34;
          const time = step * 5.2;
          return { step, holding, time };
        })
      }
    ]
  },
  // 계량 프로파일 - meteringProfile.data[].profile[] (step, backPressure, cushion)
  meteringProfile: {
    data: [
      {
        shotNumber: 577,
        profile: Array.from({ length: 21 }, (_, i) => {
          const step = i * 0.05;
          // 배압: 일정하게 유지
          const backPressure = 5 + (Math.random() - 0.5) * 0.5;
          // 쿠션 위치: 점점 증가
          const cushion = 7.7 + step * 26;
          return { step, backPressure, cushion };
        })
      },
      {
        shotNumber: 576,
        profile: Array.from({ length: 21 }, (_, i) => {
          const step = i * 0.05;
          const backPressure = 4.9 + (Math.random() - 0.5) * 0.5;
          const cushion = 7.5 + step * 26;
          return { step, backPressure, cushion };
        })
      }
    ]
  },
  // 사이클 타임 트렌드 - cycleTimeTrend.data[] (shotNumber, cycleTime, injectionTime, holdingTime, meteringTime, coolingTime)
  cycleTimeTrend: {
    data: Array.from({ length: 50 }, (_, i) => ({
      shotNumber: 528 + i,
      cycleTime: 29.8 + (Math.random() - 0.5) * 2,
      injectionTime: 5.3 + (Math.random() - 0.5) * 0.5,
      holdingTime: 5.3 + (Math.random() - 0.5) * 0.3,
      meteringTime: 3.1 + (Math.random() - 0.5) * 0.3,
      coolingTime: 15.8 + (Math.random() - 0.5) * 1
    }))
  },
  lastSyncTime: new Date().toISOString()
};

// 사출기 온도 데이터 (Machine.jsx Temperature용)
export const mockMachineTemperature = {
  // Zone별 Heater 데이터 - zoneHeaters[] (zoneName, currentTemp, setTemp, deviation, status)
  zoneHeaters: [
    { zoneName: 'Zone1 (노즐)', currentTemp: 218.5, setTemp: 220, deviation: 1.5, status: 'normal' },
    { zoneName: 'Zone2', currentTemp: 208.3, setTemp: 210, deviation: 1.7, status: 'normal' },
    { zoneName: 'Zone3', currentTemp: 204.1, setTemp: 205, deviation: 0.9, status: 'normal' },
    { zoneName: 'Zone4', currentTemp: 219.8, setTemp: 220, deviation: 0.2, status: 'normal' },
    { zoneName: 'Zone5', currentTemp: 220.1, setTemp: 220, deviation: 0.1, status: 'normal' }
  ],
  // 온도 트렌드 데이터 - tempTrend.data[] (shotNumber, zone1~5, setTemp1~5)
  tempTrend: {
    data: Array.from({ length: 20 }, (_, i) => ({
      shotNumber: 558 + i,
      zone1: 218.5 + (Math.random() - 0.5) * 3,
      zone2: 208.3 + (Math.random() - 0.5) * 3,
      zone3: 204.1 + (Math.random() - 0.5) * 3,
      zone4: 219.8 + (Math.random() - 0.5) * 3,
      zone5: 220.1 + (Math.random() - 0.5) * 3,
      setTemp1: 220,
      setTemp2: 210,
      setTemp3: 205,
      setTemp4: 220,
      setTemp5: 220
    }))
  },
  // 금형온도 데이터 - moldTemperature (averageTemp, maxDeviation, warningZoneCount, oilTemp)
  moldTemperature: {
    averageTemp: 214.2,
    maxDeviation: 1.7,
    warningZoneCount: 0,
    oilTemp: 48.5
  },
  // 온도편차현황 - deviationStatus[] (zoneName, deviation)
  deviationStatus: [
    { zoneName: 'Zone1', deviation: -1.5 },
    { zoneName: 'Zone2', deviation: -1.7 },
    { zoneName: 'Zone3', deviation: -0.9 },
    { zoneName: 'Zone4', deviation: -0.2 },
    { zoneName: 'Zone5', deviation: 0.1 }
  ],
  lastSyncTime: new Date().toISOString()
};

// 사출기 드라이브 데이터 (Machine.jsx Drive용)
export const mockMachineDrive = {
  // 사출 구동부
  injectionDrive: {
    pressure: 76.5,
    pressurePercent: 72.3,
    speed: 85.2,
    speedPercent: 68.5,
    position: 34.1,
    positionPercent: 45.2,
    elapsedTime: 2.35,
    status: '작동'
  },
  // 계량 구동부
  meteringDrive: {
    pressure: 5.2,
    pressurePercent: 52.0,
    speed: 78.5,
    speedPercent: 78.5,
    position: 34.1,
    positionPercent: 68.2,
    elapsedTime: 3.12,
    status: '대기'
  },
  // 보압 구동부
  holdingDrive: {
    pressure: 45.0,
    pressurePercent: 60.0,
    speed: 0.0,
    speedPercent: 0.0,
    position: 7.8,
    positionPercent: 15.6,
    elapsedTime: 3.50,
    status: '대기'
  },
  // 압력 트렌드 (차트용)
  pressureTrend: {
    data: Array.from({ length: 50 }, (_, i) => ({
      shotNumber: 528 + i,
      injection: 74 + Math.random() * 5,
      holding: 43 + Math.random() * 4,
      metering: 4.5 + Math.random() * 1.5
    }))
  },
  // 모터 상태 (차트용)
  motorStatus: {
    data: Array.from({ length: 50 }, (_, i) => ({
      shotNumber: 528 + i,
      current: 45 + Math.random() * 10,
      torque: 65 + Math.random() * 15,
      rpm: 1200 + Math.random() * 200
    }))
  },
  // 배압 모니터링 (차트용)
  backPressureTrend: {
    data: Array.from({ length: 50 }, (_, i) => ({
      shotNumber: 528 + i,
      backPressure: 4.8 + Math.random() * 0.8,
      upperLimit: 6.0,
      lowerLimit: 4.0
    }))
  },
  // 구동부 작동이력
  driveHistory: [
    { time: new Date(Date.now() - 5000).toISOString(), driveType: '사출', action: '전진', pressure: 76.5, speed: 85.2, position: 34.1 },
    { time: new Date(Date.now() - 8000).toISOString(), driveType: '계량', action: '회전', pressure: 5.2, speed: 78.5, position: 34.1 },
    { time: new Date(Date.now() - 12000).toISOString(), driveType: '보압', action: '유지', pressure: 45.0, speed: 0.0, position: 7.8 },
    { time: new Date(Date.now() - 18000).toISOString(), driveType: '사출', action: '후퇴', pressure: 2.1, speed: 50.0, position: 0.0 },
    { time: new Date(Date.now() - 25000).toISOString(), driveType: '계량', action: '정지', pressure: 0.0, speed: 0.0, position: 34.1 },
    { time: new Date(Date.now() - 32000).toISOString(), driveType: '사출', action: '전진', pressure: 75.8, speed: 84.5, position: 33.8 },
    { time: new Date(Date.now() - 38000).toISOString(), driveType: '보압', action: '유지', pressure: 44.5, speed: 0.0, position: 7.6 },
    { time: new Date(Date.now() - 45000).toISOString(), driveType: '계량', action: '회전', pressure: 5.1, speed: 77.8, position: 33.9 }
  ],
  lastSyncTime: new Date().toISOString()
};

// 사출기 알람 데이터 (Machine.jsx Alarm용)
export const mockMachineAlarm = {
  // 알람 현황 요약
  summary: {
    critical: 0,
    warning: 2,
    info: 3
  },
  // 알람 이력 (테이블용)
  alarmHistory: [
    { time: new Date(Date.now() - 3600000).toISOString(), severity: 'WARNING', code: 'ERR_0A_CYCTIMEXCEED', message: '싸이클 시간 초과', status: 'active', acknowledged: false },
    { time: new Date(Date.now() - 7200000).toISOString(), severity: 'WARNING', code: 'ERR_07_INJCUSHERR', message: '사출 감시 실패', status: 'resolved', acknowledged: true },
    { time: new Date(Date.now() - 86400000).toISOString(), severity: 'INFO', code: 'INF_01_MODECHANGE', message: '운전 모드 변경', status: 'resolved', acknowledged: true },
    { time: new Date(Date.now() - 172800000).toISOString(), severity: 'INFO', code: 'INF_02_PARAMCHANGE', message: '파라미터 변경', status: 'resolved', acknowledged: true },
    { time: new Date(Date.now() - 259200000).toISOString(), severity: 'INFO', code: 'INF_01_MODECHANGE', message: '운전 모드 변경', status: 'resolved', acknowledged: true },
    { time: new Date(Date.now() - 345600000).toISOString(), severity: 'WARNING', code: 'ERR_0A_CYCTIMEXCEED', message: '싸이클 시간 초과', status: 'resolved', acknowledged: true },
    { time: new Date(Date.now() - 432000000).toISOString(), severity: 'WARNING', code: 'ERR_07_INJCUSHERR', message: '사출 감시 실패', status: 'resolved', acknowledged: true },
    { time: new Date(Date.now() - 518400000).toISOString(), severity: 'INFO', code: 'INF_03_MAINTENANCE', message: '정기 점검 알림', status: 'resolved', acknowledged: true }
  ],
  // 알람 파레토 분석 (차트용)
  paretoAnalysis: {
    data: [
      { code: 'ERR_0A', count: 12, cumulative: 35 },
      { code: 'ERR_07', count: 8, cumulative: 59 },
      { code: 'INF_01', count: 6, cumulative: 76 },
      { code: 'INF_02', count: 5, cumulative: 91 },
      { code: 'INF_03', count: 3, cumulative: 100 }
    ]
  },
  // 알람 발생 타임라인 (차트용)
  timeline: {
    data: Array.from({ length: 30 }, (_, i) => {
      const d = new Date();
      d.setDate(d.getDate() - (29 - i));
      return {
        time: `${(d.getMonth() + 1).toString().padStart(2, '0')}/${d.getDate().toString().padStart(2, '0')}`,
        count: Math.floor(Math.random() * 4)
      };
    })
  },
  lastSyncTime: new Date().toISOString()
};

// SPC 데이터 (Machine.jsx SPC용)
export const mockMachineSpc = {
  parameter: 'cycle_time',
  // X-bar 관리도 데이터 (XAxis dataKey="group")
  xbarChart: {
    data: Array.from({ length: 25 }, (_, i) => {
      const baseValue = 28.0;
      const value = baseValue + (Math.random() - 0.5) * 2;
      return {
        group: i + 1,  // XAxis에서 dataKey="group" 사용
        value: value,
        ucl: 30.0,
        cl: 28.0,
        lcl: 26.0
      };
    })
  },
  // R 관리도 데이터 (범위 관리도)
  rchart: {
    data: Array.from({ length: 25 }, (_, i) => {
      const baseRange = 1.5;
      const value = baseRange + (Math.random() - 0.5) * 1;
      return {
        group: i + 1,  // XAxis에서 dataKey="group" 사용
        value: value,
        ucl: 3.0,
        cl: 1.5,
        lcl: 0.0
      };
    })
  },
  // 통계 정보
  statistics: {
    // 공정능력지수
    processCapability: {
      cp: 1.33,
      cpk: 1.25,
      pp: 1.28,
      ppk: 1.21,
      defectRate: 0.27
    },
    // 기초통계
    basicStats: {
      sampleCount: 50,
      mean: 28.15,
      stdDev: 0.67,
      min: 26.82,
      max: 29.48,
      range: 2.66
    }
  },
  // 이상 데이터 목록
  anomalies: [
    { time: '01/20 14:32', value: 29.85, type: 'UCL 근접', rule: '관리한계 경고' },
    { time: '01/19 09:15', value: 26.12, type: 'LCL 근접', rule: '관리한계 경고' },
    { time: '01/18 16:45', value: 30.21, type: 'UCL 초과', rule: '관리이탈' }
  ],
  lastSyncTime: new Date().toISOString()
};

// 권한 목록 (RoleManagementPage.jsx용)
export const mockPermissions = [
  { id: 1, code: 'dashboard.view', name: '대시보드 조회', category: '모니터링' },
  { id: 2, code: 'equipment.view', name: '설비 조회', category: '모니터링' },
  { id: 3, code: 'equipment.manage', name: '설비 관리', category: '관리' },
  { id: 4, code: 'factory.view', name: '공장 조회', category: '관리' },
  { id: 5, code: 'factory.manage', name: '공장 관리', category: '관리' },
  { id: 6, code: 'user.view', name: '사용자 조회', category: '시스템' },
  { id: 7, code: 'user.manage', name: '사용자 관리', category: '시스템' },
  { id: 8, code: 'alarm.view', name: '알람 조회', category: '모니터링' },
  { id: 9, code: 'system.admin', name: '시스템 관리', category: '시스템' }
];

// 권한 코드로 권한 객체 찾기 헬퍼 함수
const getPermissionsByCode = (codes) => {
  if (codes.includes('*')) {
    return mockPermissions; // 모든 권한
  }
  return codes.map(code => mockPermissions.find(p => p.code === code)).filter(Boolean);
};

// 사용자 목록 (UserListPage.jsx용)
export const mockUsers = [
  { id: 1, name: '관리자', email: 'admin@seoro.ai.kr', phone: '010-1234-5678', department: '시스템관리팀', position: '팀장', status: 'ACTIVE', lastLogin: new Date(Date.now() - 3600000).toISOString(), createdAt: '2025-10-01T09:00:00', roleGroup: { id: 1, name: '시스템 관리자', code: 'ADMIN', permissions: getPermissionsByCode(['*']) }, isCompanyAdmin: true, companyName: '(주)서로' },
  { id: 2, name: '공장장', email: 'manager@seoro.ai.kr', phone: '010-2345-6789', department: '생산관리팀', position: '공장장', status: 'ACTIVE', lastLogin: new Date(Date.now() - 7200000).toISOString(), createdAt: '2025-10-05T10:00:00', roleGroup: { id: 2, name: '공장 관리자', code: 'MANAGER', permissions: getPermissionsByCode(['factory.view', 'factory.manage', 'equipment.view']) }, companyName: '(주)서로' },
  { id: 3, name: '작업자1', email: 'operator1@seoro.ai.kr', phone: '010-3456-7890', department: '생산1팀', position: '작업자', status: 'ACTIVE', lastLogin: new Date(Date.now() - 14400000).toISOString(), createdAt: '2025-10-10T08:00:00', roleGroup: { id: 3, name: '작업자', code: 'OPERATOR', permissions: getPermissionsByCode(['dashboard.view', 'equipment.view']) }, companyName: '(주)서로' },
  { id: 4, name: '작업자2', email: 'operator2@seoro.ai.kr', phone: '010-4567-8901', department: '생산2팀', position: '작업자', status: 'ACTIVE', lastLogin: new Date(Date.now() - 86400000).toISOString(), createdAt: '2025-10-15T08:00:00', roleGroup: { id: 3, name: '작업자', code: 'OPERATOR', permissions: getPermissionsByCode(['dashboard.view', 'equipment.view']) }, companyName: '(주)서로' },
  { id: 5, name: '품질관리자', email: 'quality@seoro.ai.kr', phone: '010-5678-9012', department: '품질관리팀', position: '과장', status: 'ACTIVE', lastLogin: new Date(Date.now() - 172800000).toISOString(), createdAt: '2025-10-20T09:00:00', roleGroup: { id: 4, name: '뷰어', code: 'VIEWER', permissions: getPermissionsByCode(['dashboard.view']) }, companyName: '(주)서로' }
];

// 권한 그룹 (RoleManagementPage.jsx용)
export const mockRoleGroups = [
  { id: 1, name: '시스템 관리자', code: 'ADMIN', description: '전체 시스템 관리 권한', permissions: getPermissionsByCode(['*']) },
  { id: 2, name: '공장 관리자', code: 'MANAGER', description: '공장 및 설비 관리 권한', permissions: getPermissionsByCode(['factory.view', 'factory.manage', 'equipment.view', 'equipment.manage', 'user.view']) },
  { id: 3, name: '작업자', code: 'OPERATOR', description: '설비 운영 및 모니터링 권한', permissions: getPermissionsByCode(['dashboard.view', 'equipment.view', 'alarm.view']) },
  { id: 4, name: '뷰어', code: 'VIEWER', description: '모니터링 조회 권한', permissions: getPermissionsByCode(['dashboard.view']) }
];

// 공지사항 (NoticeManagementPage.jsx용)
export const mockNotices = [
  { id: 1, title: '시스템 점검 안내', content: '2025년 12월 20일 새벽 2시~4시 시스템 점검이 예정되어 있습니다.', category: '시스템', type: 'urgent', viewCount: 156, createdAt: '2025-11-15T09:00:00', isNotice: true, isActive: true, startDate: '2025-12-15', endDate: '2025-12-20' },
  { id: 2, title: '신규 기능 업데이트', content: 'AI 분석 기능이 새롭게 추가되었습니다. 사이드바의 AI 분석 메뉴를 통해 이용하실 수 있습니다.', category: '업데이트', type: 'update', viewCount: 89, createdAt: '2025-11-10T14:30:00', isNotice: false, isActive: true, startDate: '2025-12-01', endDate: '2025-12-31' },
  { id: 3, title: '사용자 매뉴얼 배포', content: '최신 사용자 매뉴얼이 업데이트 되었습니다. 도움말 메뉴에서 확인하세요.', category: '공지', type: 'notice', viewCount: 45, createdAt: '2025-11-05T11:00:00', isNotice: false, isActive: true, startDate: '2025-12-05', endDate: '2025-12-25' }
];

// 최근 알람
export const mockRecentAlarms = [
  { id: 1, equipmentId: 1, equipmentName: 'INJ-001', factoryName: '본사 공장', code: 'A001', message: '유압유 온도 경고', severity: 'WARNING', occurredAt: new Date(Date.now() - 3600000).toISOString() },
  { id: 2, equipmentId: 5, equipmentName: 'INJ-005', factoryName: '본사 공장', code: 'E001', message: '설비 정지', severity: 'ERROR', occurredAt: new Date(Date.now() - 7200000).toISOString() },
  { id: 3, equipmentId: 3, equipmentName: 'INJ-003', factoryName: '본사 공장', code: 'I001', message: '대기 상태 전환', severity: 'INFO', occurredAt: new Date(Date.now() - 10800000).toISOString() }
];

// 위젯 설정 (Machine.jsx Widget용)
// 4열 그리드, 12슬롯 레이아웃:
// Row 1: [기본정보 1x1] [알람이력 1x2] [온도 2x1      ]
//        slot 1        slot 2        slot 3, 4
// Row 2: [기본사출정보] [알람이력계속] [압력 2x1      ]
//        slot 5        (occupied)    slot 7, 8
// Row 3: [사용자모듈]   [사용자모듈]  [에너지 2x1    ]
//        slot 9        slot 10       slot 11, 12
export const mockWidgetConfig = [
  { id: 1, widgetType: '기본정보', widgetSize: '1x1', slotNumber: 1 },
  { id: 2, widgetType: '알람이력', widgetSize: '1x2', slotNumber: 2 },
  { id: 3, widgetType: '온도', widgetSize: '2x1', slotNumber: 3 },
  { id: 4, widgetType: '기본사출정보', widgetSize: '1x1', slotNumber: 5 },
  { id: 5, widgetType: '압력', widgetSize: '2x1', slotNumber: 7 },
  { id: 6, widgetType: '사용자모듈', widgetSize: '1x1', slotNumber: 9, customConfig: {
    title: '사용자모듈',
    chartType: 'line',
    xAxis: 'shotNumber',
    yAxis: 'pressure'
  }},
  { id: 7, widgetType: '사용자모듈', widgetSize: '1x1', slotNumber: 10, customConfig: {
    title: '사용자모듈',
    chartType: 'line',
    xAxis: 'shotNumber',
    yAxis: 'temperature'
  }},
  { id: 8, widgetType: '에너지', widgetSize: '2x1', slotNumber: 11 }
];

// 위젯 데이터 (각 위젯 타입별 데이터 형식)
export const mockWidgetData = {
  // 온도 위젯용 - 배열 형태 (shotNumber, zone1~5)
  temperature: Array.from({ length: 20 }, (_, i) => ({
    shotNumber: 558 + i,
    zone1: 218.5 + (Math.random() - 0.5) * 2,
    zone2: 204.3 + (Math.random() - 0.5) * 2,
    zone3: 211.2 + (Math.random() - 0.5) * 2,
    zone4: 219.8 + (Math.random() - 0.5) * 2,
    zone5: 220.1 + (Math.random() - 0.5) * 2
  })),
  // 압력 위젯용 - 배열 형태 (shotNumber, injection, holding, metering, backPressure)
  pressure: Array.from({ length: 20 }, (_, i) => ({
    shotNumber: 558 + i,
    injection: 75 + (Math.random() - 0.5) * 5,
    holding: 3 + (Math.random() - 0.5) * 1,
    metering: 2 + (Math.random() - 0.5) * 1,
    backPressure: 4 + (Math.random() - 0.5) * 1
  })),
  // 에너지 위젯용 - 배열 형태
  energy: Array.from({ length: 20 }, (_, i) => ({
    shotNumber: 558 + i,
    power: 75 + (Math.random() - 0.5) * 20
  })),
  // 기본정보 위젯용 - productName, shotCount, cycleTime, cavityCount
  'basic-info': {
    basicInfo: {
      productName: '62-1',
      shotCount: 577,
      cycleTime: 29.8,
      cavityCount: 4
    }
  },
  // 기본사출정보 위젯용 - injectionInfo 객체
  'injection-info': {
    injectionInfo: {
      maxPressure: 76.0,
      startPosition: 34.1,
      switchPosition: 7.7,
      time: 5.3,
      speed: 30.0,
      suckbackTime: 0.6,
      suckbackSpeed: 50.0
    }
  },
  // 알람이력 위젯용 - alarmHistory 배열
  'alarm-history': {
    alarmHistory: [
      { code: 'ERR_0A_CYCTIMEXCEED', message: '싸이클 시간 초과', severity: 'WARNING', time: new Date(Date.now() - 86400000).toISOString(), status: 'resolved' },
      { code: 'ERR_0A_CYCTIMEXCEED', message: '싸이클 시간 초과', severity: 'WARNING', time: new Date(Date.now() - 172800000).toISOString(), status: 'resolved' },
      { code: 'ERR_07_INJCUSHERR', message: '사출 감시 실패', severity: 'WARNING', time: new Date(Date.now() - 432000000).toISOString(), status: 'resolved' },
      { code: 'ERR_07_INJCUSHERR', message: '사출 감시 실패', severity: 'WARNING', time: new Date(Date.now() - 518400000).toISOString(), status: 'resolved' },
      { code: 'ERR_0A_CYCTIMEXCEED', message: '싸이클 시간 초과', severity: 'WARNING', time: new Date(Date.now() - 691200000).toISOString(), status: 'resolved' },
      { code: 'ERR_0A_CYCTIMEXCEED', message: '싸이클 시간 초과', severity: 'WARNING', time: new Date(Date.now() - 777600000).toISOString(), status: 'resolved' }
    ]
  }
};

// 사용자모듈(커스텀 위젯)용 샷 데이터 - 20개 샷 데이터 생성
// 필드명은 Machine.jsx의 사용자모듈 렌더링 코드와 일치해야 함
export const mockCustomWidgetData = Array.from({ length: 20 }, (_, i) => {
  const shotNum = 558 + i;
  return {
    shotNumber: shotNum,
    // 온도 데이터 (zone1~5) - temperature 차트용
    zone1: 218.5 + (Math.random() - 0.5) * 2,
    zone2: 204.3 + (Math.random() - 0.5) * 2,
    zone3: 211.2 + (Math.random() - 0.5) * 2,
    zone4: 219.8 + (Math.random() - 0.5) * 2,
    zone5: 220.1 + (Math.random() - 0.5) * 2,
    // 압력 데이터 - pressure 차트용
    injection: 75 + (Math.random() - 0.5) * 5,
    holding: 3 + (Math.random() - 0.5) * 1,
    metering: 2 + (Math.random() - 0.5) * 1,
    backPressure: 4 + (Math.random() - 0.5) * 1,
    // 에너지 데이터
    power: 75 + (Math.random() - 0.5) * 20
  };
});

// 샷 히스토리 (양/불 탭용)
export const mockShotHistory = {
  shots: Array.from({ length: 100 }, (_, i) => {
    const shotNum = 577 - i;
    const isGood = Math.random() > 0.05; // 95% 양품
    return {
      shotCount: shotNum,
      craftId: '62-1',
      chargePosi1: 34 + (Math.random() - 0.5) * 2,
      injTime: 5.3 + (Math.random() - 0.5) * 0.5,
      injStartPosi: 34 + (Math.random() - 0.5) * 1,
      injEndPosi: 7.7 + (Math.random() - 0.5) * 0.5,
      temp1Current: 218 + (Math.random() - 0.5) * 3,
      injSpeed1: 30 + (Math.random() - 0.5) * 5,
      injPress1: 76 + (Math.random() - 0.5) * 10,
      qualityStatus: isGood ? 'GOOD' : 'BAD'
    };
  })
};

// 감시1 데이터
// 필드명은 MonitoringWatch1.jsx의 매핑과 일치해야 함
export const mockWatch1Data = {
  current: {
    // 테이블1 데이터
    moldCloseTime: 2.68,
    moldProtectTime: 0.70,
    highPressureTime: 0.39,
    moldOpenTime: 2.86,
    injectionTime: 10.3,
    cycleTime: 21.32,
    ejectTime: 3.96,
    moldOpenPosition: 261.6,
    // 테이블2 데이터 (API 매핑 필드명 사용)
    injMaxPressure: 76,
    holdPressure: 5.30,
    turnPosition: 8.4,
    turnTime: 2.00,
    turnPressure: 59,
    cushionAmount: 7.6,
    injStartPosition: 34.1,
    meteringPosition: 3.10,
    suckbackTime: 0.57
  },
  prevShot: {
    // 테이블1 데이터
    moldCloseTime: 2.67,
    moldProtectTime: 0.70,
    highPressureTime: 0.38,
    moldOpenTime: 2.90,
    injectionTime: 57.0,
    cycleTime: 29.04,
    ejectTime: 3.95,
    moldOpenPosition: 261.6,
    // 테이블2 데이터 (API 매핑 필드명 사용)
    injMaxPressure: 76,
    holdPressure: 5.30,
    turnPosition: 8.4,
    turnTime: 2.00,
    turnPressure: 60,
    cushionAmount: 7.6,
    injStartPosition: 34.0,
    meteringPosition: 3.11,
    suckbackTime: 0.57
  }
};

// 감시2 데이터 - 샷 이력 테이블용
// MonitoringWatch2.jsx의 컬럼: shotCount, cycleTime, holdTime1(injHoldTime), chargeTime, injStartPosi, turnPosi, injEndPosi, fetchTime
export const mockWatch2Data = {
  shots: Array.from({ length: 50 }, (_, i) => {
    const shotNum = 577 - i;
    return {
      shotCount: shotNum,
      cycleTime: 29.8 + (Math.random() - 0.5) * 2,
      holdTime1: 2.0 + (Math.random() - 0.5) * 0.3,
      chargeTime: 3.1 + (Math.random() - 0.5) * 0.3,
      injStartPosi: 34.1 + (Math.random() - 0.5) * 1,
      turnPosi: 8.4 + (Math.random() - 0.5) * 0.5,
      injEndPosi: 7.7 + (Math.random() - 0.5) * 0.5,
      fetchTime: 3.96 + (Math.random() - 0.5) * 0.3
    };
  })
};

// LSTM 불량 원인 분석 데이터 (LSTMDefectAnalysis.jsx용)
export const mockLSTMAnalysis = {
  // Attention Weight 데이터 (시간 구간별)
  attention_weights: Array.from({ length: 20 }, (_, i) => ({
    shot_index: 558 + i,
    label: `Shot ${558 + i}`,
    weight: 0.03 + Math.random() * 0.07 + (i === 15 ? 0.15 : 0) // 특정 지점에서 높은 attention
  })),
  // 이상 점수
  anomaly_score: 0.72,
  threshold: 0.65,
  is_anomaly: true,
  // Feature 중요도 (불량 원인 인자)
  feature_importance: [
    { feature: 'inj_speed_1', feature_kr: '사출속도', importance: 85, rank: 1 },
    { feature: 'temp_1_current', feature_kr: '용융온도', importance: 72, rank: 2 },
    { feature: 'inj_press_1', feature_kr: '충진압력', importance: 65, rank: 3 },
    { feature: 'charge_posi_1', feature_kr: '계량위치', importance: 48, rank: 4 },
    { feature: 'inj_end_posi', feature_kr: '쿠션량', importance: 35, rank: 5 }
  ],
  // 추천값 (공정 튜닝)
  recommendations: [
    { feature: 'inj_speed_1', feature_kr: '사출속도', current_value: 32.5, recommended_value: 30.0, direction: 'decrease', status: 'out_of_range' },
    { feature: 'temp_1_current', feature_kr: '용융온도', current_value: 225.3, recommended_value: 220.0, direction: 'decrease', status: 'out_of_range' },
    { feature: 'inj_press_1', feature_kr: '충진압력', current_value: 78.5, recommended_value: 76.0, direction: 'decrease', status: 'normal' },
    { feature: 'charge_posi_1', feature_kr: '계량위치', current_value: 33.8, recommended_value: 34.1, direction: 'increase', status: 'normal' },
    { feature: 'inj_end_posi', feature_kr: '쿠션량', current_value: 7.9, recommended_value: 7.7, direction: 'decrease', status: 'normal' }
  ],
  // 모델 신뢰도
  confidence: {
    overall: 87.5,
    lstm_accuracy: 92.3,
    attention_confidence: 85.7,
    data_quality: 89.2
  }
};

// ETL 상태 (SystemManagementPage.jsx용)
export const mockETLStatus = {
  is_running: false,
  last_run: new Date(Date.now() - 300000).toISOString(),
  last_success: new Date(Date.now() - 300000).toISOString(),
  records_processed: 15420
};

// ETL 히스토리
export const mockETLHistory = Array.from({ length: 10 }, (_, i) => ({
  id: i + 1,
  sync_time: new Date(Date.now() - (i + 1) * 3600000).toISOString(),
  sync_status: i === 3 ? 'FAILED' : 'SUCCESS',
  total_records: 1500 + Math.floor(Math.random() * 500),
  table_list: 'equipment, shot_data, alarm',
  error_message: i === 3 ? '연결 시간 초과' : null
}));

// 로그인 로그 (SystemManagementPage.jsx용)
export const mockLoginLogs = Array.from({ length: 20 }, (_, i) => ({
  id: i + 1,
  createdAt: new Date(Date.now() - i * 3600000).toISOString(),
  eventType: i % 10 === 0 ? 'LOGOUT' : i % 15 === 0 ? 'LOGIN_FAILED' : 'LOGIN',
  username: mockUsers[i % 5].name,
  email: mockUsers[i % 5].email,
  ipAddress: `192.168.1.${100 + i}`,
  failureReason: i % 15 === 0 ? '비밀번호 오류' : null
}));

// AI 챗봇 응답 (사용하지 않음 - api.js에서 직접 처리)
export const mockAIResponse = {
  intent: 'query',
  natural_language: '현재 가동 중인 설비는 14대입니다.',
  blocks: [],
  success: true
};

// 공장 상세 (FactoryDetailPage.jsx용)
export const mockFactoryDetail = {
  1: {
    id: 1,
    factoryName: '본사 공장',
    factoryCode: 'FAC-001',
    address: '경기도 화성시 동탄대로 123',
    description: '메인 생산 공장',
    managerName: '김공장',
    phone: '031-123-4567',
    email: 'factory1@seoro.ai.kr',
    createdAt: '2020-01-15T00:00:00',
    temperature: 22.5,
    humidity: 45.0,
    totalEquipment: 8,
    runningEquipment: 6,
    idleEquipment: 1,
    stoppedEquipment: 1,
    operationRate: 75,
    status: 'NORMAL',
    lastInspectionDate: '2025-10-15'
  },
  2: {
    id: 2,
    factoryName: '제2공장',
    factoryCode: 'FAC-002',
    address: '충청남도 천안시 서북구 456',
    description: '보조 생산 공장',
    managerName: '이공장',
    phone: '041-234-5678',
    email: 'factory2@seoro.ai.kr',
    createdAt: '2021-06-20T00:00:00',
    temperature: 23.0,
    humidity: 48.0,
    totalEquipment: 4,
    runningEquipment: 3,
    idleEquipment: 1,
    stoppedEquipment: 0,
    operationRate: 75,
    status: 'NORMAL',
    lastInspectionDate: '2025-10-08'
  },
  3: {
    id: 3,
    factoryName: '제3공장',
    factoryCode: 'FAC-003',
    address: '경상북도 구미시 산동면 789',
    description: '신규 확장 공장',
    managerName: '박공장',
    phone: '054-345-6789',
    email: 'factory3@seoro.ai.kr',
    createdAt: '2023-01-10T00:00:00',
    temperature: 21.5,
    humidity: 42.0,
    totalEquipment: 6,
    runningEquipment: 5,
    idleEquipment: 1,
    stoppedEquipment: 0,
    operationRate: 83,
    status: 'NORMAL',
    lastInspectionDate: '2025-10-22'
  }
};

// 설비 상세 (EquipmentDetailPage.jsx용)
export const mockEquipmentDetail = mockEquipments.reduce((acc, eq) => {
  acc[eq.id] = {
    ...eq,
    installDate: '2023-03-15',
    lastMaintenanceDate: '2025-12-10',
    nextMaintenanceDate: '2026-03-10',
    purchasePrice: 150000000 + eq.tonnage * 100000
  };
  return acc;
}, {});

// 사용자 상세 (UserDetailPage.jsx용)
export const mockUserDetail = mockUsers.reduce((acc, user) => {
  acc[user.id] = { ...user };
  return acc;
}, {});

// DB 연결 상태 (SystemManagementPage.jsx용)
export const mockDBConnections = {
  databases: {
    raw_db: { connected: true },
    monitoring_db: { connected: true }
  }
};

// 시스템 설정 (SystemManagementPage.jsx용)
export const mockSystemSettings = {
  systemName: '사출 통합 관제 시스템',
  companyName: '(주)서로',
  companyCode: 'SEORO',
  schemaName: 'seoro',
  businessNumber: '123-45-67890',
  representativeName: '홍길동',
  contactEmail: 'ceo@seoro.ai.kr',
  contactPhone: '032-721-7118',
  address: '인천광역시 연수구 송도미래로11번길27, 스마트스퀘어 A동 1501호',
  logoUrl: '/images/logo.png',
  faviconUrl: '/favicon.ico',
  refreshInterval: 30,
  timezone: 'Asia/Seoul',
  maxLoginAttempts: 5,
  lockDurationMinutes: 30,
  notifyWeb: true,
  notifyEmail: true,
  notifySms: false,
  notifyPush: true
};

// 일일 보고서 (DailyReportModal.jsx용)
export const mockDailyReport = {
  header: {
    reportDate: new Date().toISOString(),
    category: '전사',
    author: '시스템',
    createdAt: new Date().toISOString()
  },
  equipmentStatus: {
    totalEquipment: 12,
    averageOperationRate: 78.5,
    totalShots: 15420,
    totalAlarmCount: 23,
    dailyProduction: 58320,
    defectCount: 1245,
    energyProduction: 2450.75
  },
  oee: {
    availability: 89.2,
    performance: 92.5,
    quality: 97.9,
    oee: 80.8
  },
  aiSummary: `## 일일 생산 분석 요약

### 주요 성과
- 당일 가동률 **78.5%**로 목표치(75%) 대비 **3.5%p 초과** 달성
- 양품률 **97.9%**로 우수한 품질 수준 유지
- 총 생산량 **59,565개** 달성

### 개선 필요 사항
1. **INJ-005 설비**: 알람 발생 빈도 높음 (8건) - 예방 점검 필요
2. **B라인 사이클 타임**: 목표 대비 5% 초과 - 공정 조건 점검 권장

### 내일 예상
- 정기 점검 예정 설비: INJ-003
- 예상 가동률: 75~80%`
};

// 주간 보고서 (WeeklyReportModal.jsx용)
export const mockWeeklyReport = {
  header: {
    weekStartDate: new Date(Date.now() - 6 * 24 * 60 * 60 * 1000).toISOString(),
    weekEndDate: new Date().toISOString(),
    category: '전사',
    author: '시스템',
    createdAt: new Date().toISOString()
  },
  equipmentStatus: {
    totalEquipment: 12,
    averageOperationRate: 76.8,
    totalShots: 98540,
    totalAlarmCount: 156,
    weeklyProduction: 385420,
    defectCount: 8245,
    energyProduction: 16850.50
  },
  oee: {
    availability: 87.5,
    performance: 91.2,
    quality: 97.5,
    oee: 77.8
  },
  aiSummary: `## 주간 생산 분석 요약

### 주요 성과
- 주간 평균 가동률 **76.8%**로 전주 대비 **2.1%p 상승**
- 양품률 **97.5%** 유지 (목표: 97.0%)
- 총 생산량 **393,665개** 달성

### 일별 가동률 추이
| 요일 | 가동률 | 생산량 |
|------|--------|--------|
| 월요일 | 78.2% | 58,120 |
| 화요일 | 79.5% | 59,450 |
| 수요일 | 75.8% | 54,230 |
| 목요일 | 76.2% | 55,890 |
| 금요일 | 74.5% | 52,180 |
| 토요일 | 72.1% | 48,500 |
| 일요일 | - | 정비일 |

### 주요 알람 분석
1. **사이클 시간 초과** (45건) - 주요 발생 설비: INJ-003, INJ-007
2. **온도 경고** (32건) - 주요 발생 설비: INJ-001, INJ-005
3. **압력 이상** (28건) - 주요 발생 설비: INJ-002

### 차주 개선 계획
- INJ-003 금형 온도 센서 교체 예정
- B라인 전체 정기 점검 (수요일)`
};

// 월간 보고서 (MonthlyReportModal.jsx용)
export const mockMonthlyReport = {
  header: {
    year: new Date().getFullYear(),
    month: new Date().getMonth() + 1,
    category: '전사',
    author: '시스템',
    createdAt: new Date().toISOString()
  },
  equipmentStatus: {
    totalEquipment: 12,
    averageOperationRate: 75.2,
    totalShots: 425680,
    totalAlarmCount: 687,
    monthlyProduction: 1584320,
    defectCount: 35420,
    energyProduction: 72450.25
  },
  oee: {
    availability: 86.8,
    performance: 90.5,
    quality: 97.2,
    oee: 76.4
  },
  aiSummary: `## 월간 생산 분석 요약

### 월간 성과 요약
- 월간 평균 가동률 **75.2%** (전월 대비 -1.3%p)
- 총 생산량 **1,619,740개** (목표 대비 98.2%)
- 양품률 **97.2%** 유지

### 주차별 성과
| 주차 | 가동률 | 생산량 | OEE |
|------|--------|--------|-----|
| 1주차 | 76.5% | 412,350 | 78.2% |
| 2주차 | 77.2% | 425,680 | 79.1% |
| 3주차 | 74.8% | 398,450 | 75.8% |
| 4주차 | 72.3% | 383,260 | 72.5% |

### 설비별 가동률 순위
1. **INJ-002**: 82.5% (최우수)
2. **INJ-008**: 81.2%
3. **INJ-001**: 79.8%
...
10. **INJ-005**: 68.5% (개선 필요)

### 주요 개선 사항
- 예방 정비 실시: 5회
- 설비 고장 건수: 12건 (전월 대비 -3건)
- 평균 MTBF: 256시간

### 다음 달 계획
1. INJ-005 오버홀 정비 예정
2. 신규 금형 3종 도입 (A라인)
3. 에너지 절감 목표: 5% 감소`
};
